import "./DynamicFormLayout.scss";

import { IDynamicForm } from "config";
import { ModalFlowLayout } from "containers/DynamicForm/DynamicFormLayouts/ModalFlowLayout";
import { QuoteReviewLayout } from "containers/DynamicForm/DynamicFormLayouts/QuoteReviewLayout/QuoteReviewLayout";
import { ReviewLayout } from "containers/DynamicForm/DynamicFormLayouts/ReviewLayout/ReviewLayout";
import { TerminalLayout } from "containers/DynamicForm/DynamicFormLayouts/TerminalLayout";
import { TriviaLayout } from "containers/DynamicForm/DynamicFormLayouts/TriviaLayout/TriviaLayout";
import { VerticalLayout } from "containers/DynamicForm/DynamicFormLayouts/VerticalLayout";

import { PurchasePolicyLayout } from "./PurchasePolicyLayout/PurchasePolicyLayout";

interface IProps {
  items: IDynamicForm["items"];
  layout: IDynamicForm["layout"];
  slug: IDynamicForm["slug"];
  groups?: IDynamicForm["groups"];
  leadingNavigationButton?: IDynamicForm["leadingNavigationButton"];
}

export function DynamicFormLayout({
  groups = [],
  items,
  layout,
  leadingNavigationButton,
  slug,
}: IProps) {
  switch (layout) {
    case "vertical":
      return <VerticalLayout groups={groups} items={items} />;
    case "modal":
      return (
        <ModalFlowLayout
          groups={groups}
          items={items}
          leadingNavigationButton={leadingNavigationButton}
        />
      );
    case "review":
      return <ReviewLayout items={items} slug={slug} />;
    case "quoteReview":
      return <QuoteReviewLayout groups={groups} items={items} slug={slug} />;
    case "purchasePolicy":
    case "purchaseSuccess":
      return <PurchasePolicyLayout items={items} slug={slug} />;
    case "terminal":
      return <TerminalLayout />;
    case "trivia":
      return <TriviaLayout items={items} slug={slug} />;
    default:
      return null;
  }
}
